module.exports = __webpack_public_path__ + "assets/infographic-icon-2.8a661013.svg";